import React from 'react'
import SbEditable from 'storyblok-react'

import ButtonPrimary from './../ButtonPrimary'
import LinkItem from './../LinkItem'
import Image from './../Image'

import styles from './styles.module.scss'

const Newsletter = (props) => {
	return (
		<SbEditable content={props.blok}>
			<section className={styles['newsletter']} id='newsletter' style={{ color: props.blok.background_color }}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                <div className='container'>
                    <div className={`row ${styles['newsletter__row']}`}>
                        <div className={`col col-12 col-sm-7 ${styles['newsletter__form-wrapper']}`}>
                            <h3 className={`heading-3 ${styles['newsletter__description']}`}><b>{props.blok.heading}</b></h3>
                            <form
                                action='https://d-rev.us2.list-manage.com/subscribe/post?u=74fc32b8c6ca7c85d7e9614f4&amp;id=bad43788c6'
                                method='post'
                                name='mc-embedded-subscribe-form'
                                target='_blank'
                                noValidate
                                className={styles['newsletter__form']}
                            >
                                <input
                                    className={`body ${styles['newsletter__form-input']}`}
                                    type='text'
                                    name='NAME'
                                    id='mce-NAME'
                                    placeholder='First & Last name'
                                    required
                                    autoComplete='false'
                                />
                                <input
                                    className={`body ${styles['newsletter__form-input']}`}
                                    type='email'
                                    name='EMAIL'
                                    id='mce-EMAIL'
                                    placeholder='Email address'
                                    required
                                    autoComplete='false'
                                />
                                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden='true'>
                                    <input
                                        type='text'
                                        name='b_74fc32b8c6ca7c85d7e9614f4_bad43788c6'
                                        tabIndex='-1'
                                        defaultValue=''
                                    />
                                </div>
                                <div className={styles['newsletter__form-footer']}>
                                    <ButtonPrimary className={styles['newsletter__submit']} label='Subscribe' />
                                </div>
                            </form>
                        </div>
                        {props.blok.links && (
                            <div className={`col col-12 col-sm-5`}>
                                <ul className={styles['newsletter__links-list']}>
                                    {props.blok.links.map((blok, i) => {
                                        return (
                                            <LinkItem key={i} blok={blok} />
                                        )
                                    })}
                                </ul>
                            </div>
                        )}
                        {props.blok.image && props.blok.image.filename && (
                            <figure className={styles['newsletter__media']}>
                                <Image blok={props.blok} className={styles['newsletter__media-image']} image={props.blok.image} params={{ maxWidth: 650 }} />
                            </figure>
                        )}
                    </div>
                </div>
            </section>
		</SbEditable>
	)
}

export default Newsletter
